<template>
  <v-layout row wrap justify-center>
    <debit
      @reset="reset"
      @saved="saved"
      v-model="debit"
      v-if="initList && !reportView"
      class="flex xs12 shadow pa-0 mb-4"
    />

    <bill-preview v-model="dialog">
      <debit-bill slot="form" v-bind="showItem"> </debit-bill>
    </bill-preview>

    <form-dialog v-model="editDialog" :title="$t('edit_bill')" width="1000px">
      <debit
        ref="edit"
        :edit="true"
        @reset="reset"
        @saved="saved"
        v-if="editDialog"
        v-model="itemForEdit"
        class="flex xs12 shadow pa-0"
      />
    </form-dialog>

    <v-card class="shadow flex xs12 pa-0">
      <div
        class="
          py-1
          px-3
          secondary
          white--text
          font-weight-bold
          di-flex
          justify-center
          align-center
        "
        v-if="!accountView"
      >
        <span class="py-1">{{ $t("cash_payments") }}</span>
        <v-spacer />
        <div v-if="!dashboardView && !accountView">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn color="white" class="py-0 ma-0" flat dark v-on="on">
                <!-- <v-icon class="mx-2">more_vert</v-icon> -->
                <strong class="mt-1"> {{ selected_currency.name }} </strong>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                :key="index"
                @click="currencyChanged(item)"
                v-for="(item, index) in currencies"
              >
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </div>
      <v-card-text class="pt-3">
        <v-layout row wrap class="flex-row align-center justify-start">
          <v-checkbox
            singleLine
            hideDetails
            color="primary"
            @change="initData"
            v-model="filter_date"
            style="max-width: 24px"
            v-if="!dashboardView && !accountView"
          />
          <v-date
            singleLine
            :hideDetails="true"
            @input="initData"
            format="YYYY-MM-DD"
            v-model="start_date"
            value-type="YYYY-MM-DD"
            :placeholder="$t('start_date')"
            input_id="start_date_expo_dabite"
            :disabled="!filter_date && !loading"
            v-if="!dashboardView && !accountView"
            class="mx-2 flex xs12 md2 hide-details"
          />

          <v-date
            singleLine
            :hideDetails="true"
            @input="initData"
            v-model="end_date"
            format="YYYY-MM-DD"
            value-type="YYYY-MM-DD"
            input_id="start_date_expoeee"
            :placeholder="$t('end_date')"
            :disabled="!filter_date && !loading"
            v-if="!dashboardView && !accountView"
            class="mx-2 flex xs12 md2 hide-details"
          />
          <v-spacer />
          <v-text-field
            outline
            hide-details
            v-model="search"
            v-if="!dashboardView"
            style="max-width: 420px"
            class="flex xs12 rounded"
            :placeholder="$t('search')"
            prepend-inner-icon="search"
          />
          <v-btn
            flat
            icon
            class="mx-0"
            @click="initData"
            :loading="loading"
            color="grey darken-2"
            v-if="!dashboardView && !accountView"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-btn
            flat
            icon
            class="mx-0"
            color="grey darken-2"
            @click="printTable(false)"
          >
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn
            flat
            icon
            class="mx-0"
            color="grey darken-2"
            @click="printTable(true)"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
        </v-layout>

        <v-data-table
          ref="tbl"
          :loading="loading"
          :headers="headers"
          disable-initial-sort
          :items="computedItems"
          :total-items="meta.total"
          :pagination.sync="pagination"
          :rows-per-page-items="per_page"
          :search="!initList ? search || externalSearch : ''"
        >
          <template slot="items" slot-scope="props">
            <tr
              @click="props.expanded = !props.expanded"
              @dblclick="$emit('customer_changed', props.item.customer_id,props.item.customer)"
            >
              <td :class="{ red: props.item.deleted_at }">
                {{ props.item.number }}
              </td>
              <td>{{ props.item.customer.full_name }}</td>
              <td
                :class="{
                  'red--text': props.item.amount < 0,
                  'activeColor--text': props.item.amount > 0,
                }"
              >
                {{ props.item.amount | currency }}
              </td>
              <td
                :class="{
                  'red--text': props.item.amount < 0,
                  'activeColor--text': props.item.amount > 0,
                }"
              >
                {{ smbl(props.item.currency_id) }}
              </td>
              <td>{{ props.item.receiver.name }}</td>
              <td>
                <span class="wrap--text">{{ props.item.description }}</span>
              </td>
              <td>{{ props.item.date | persianDateFilter(true) }}</td>
              <td>{{ props.item.date | persianDateFilter }}</td>
              <td>{{ props.item.time }}</td>
              <td>{{ props.item.risk_category}}</td>
              <td v-if="trashed">{{ props.item.deleted_at }}</td>
              <td v-if="reportView">
                {{ props.item.user && props.item.user.name }}
              </td>
              <td>
                <v-btn
                  icon
                  flat
                  small
                  class="ma-0"
                  v-if="can.view"
                  color="grey darken-1"
                  @click="showDebit(props.item)"
                >
                  <v-icon>launch</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  flat
                  class="ma-0"
                  color="grey darken-1"
                  @click="editItem(props.item)"
                  v-if="can.edit && props.item.editable"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  icon
                  flat
                  small
                  class="ma-0"
                  color="grey darken-1"
                  @click="deleteItem(props.item)"
                  v-if="can.delete && props.item.editable"
                >
                  <v-icon>delete_outline</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:expand="{ item }">
            <v-divider></v-divider>
            <file-viewer :files="item.files" />
          </template>
          <template slot="footer">
            <tr
              :key="key"
              class="font-weight-bold"
              v-for="(value, key) in summery.currencies"
            >
              <td colspan="2">{{ $t("total") }} {{ smbl(value) }}</td>
              <td colspan="100%" class="lr--text px-3">
                {{ summery.amount[value] | currency({ symbol: smbl(value) }) }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-layout>
</template>
<script>
import curjs from "currency.js";
import debounce from "@/plugins/vDebounce";
import { customersMixin } from "@/mixins/index.js";

export default {
  mixins: [customersMixin],
  name: "debitsTable",
  props: {
    date: { default: null },
    st_date: { default: null },
    en_date: { default: null },
    trashed: { default: false },
    initList: { default: true },
    brnch_name: { default: "" },
    debits: { default: () => [] },
    reportView: { default: false },
    externalSearch: { default: "" },
    accountView: { default: false },
    dashboardView: { default: false },
    branch_id: { default: undefined },
    customer_id: { default: undefined },
    risk_category: { default: undefined },
  },

  data: () => ({
    search: null,
    items: [],
    loading: false,
    dialog: false,
    editIndex: -1,
    editDialog: false,
    selected_currency: {
      id: undefined,
      name: "ALl Currencies",
    },
    showItem: {
      debit: {
        files: [],
      },
      customer: {},
    },
    debit: {
      files: [],
      date: new Date().toLocaleDateString("en-ca"),
      time: new Date().toLocaleTimeString([], { hour12: false }),
    },
    itemForEdit: {},
    meta: {
      total: 0,
      perPage: 0,
      current_page: 0,
    },
    filter_date: true,
    pagination: { page: 1, rowsPerPage: 100 },
    start_date: new Date().toLocaleDateString("en-ca"),
    end_date: new Date().toLocaleDateString("en-ca"),
  }),
  computed: {
    currencies() {
      let items = this.initialData.currencies;
      return [{ id: undefined, name: "ALl Currencies" }, ...items];
    },
    computedItems() {
      if (this.initList) return this.items;
      return this.debits;
    },
    summery() {
      let amount = {};
      let currencies = {};

      this.computedItems.forEach((item) => {
        //sum amounts by currency
        if (!amount[item.currency_id]) amount[item.currency_id] = 0;
        amount[item.currency_id] =
          Number(amount[item.currency_id]) + Number(item.amount);

        // add amount or exchange currency to used list
        if (item.currency_id) currencies[item.currency_id] = item.currency_id;
      });
      return { amount, currencies };
    },

    can() {
      return {
        add: this.userCan("add_debits"),
        view: this.userCan("view_debits"),
        edit: this.userCan("edit_debits"),
        delete: this.userCan("delete_debits"),
        any:
          this.userCan("edit_debits") ||
          this.userCan("view_debits") ||
          this.userCan("delete_debits"),
      };
    },

    headers: (vm) => {
      let items = [
        {
          width: "30",
          value: "number",
          sortable: false,
          text: vm.$t("tr"),
        },
        {
          sortable: false,
          text: vm.$t("customer"),
          value: "customer.full_name",
        },
        {
          value: "amount",
          sortable: false,
          text: vm.$t("amount"),
          computed: (item) => curjs(item.amount).format({ symbol: "" }),
        },
        {
          width: 30,
          value: "currency",
          sortable: false,
          text: vm.$t("currency"),
          computed: (item) => `${vm.smbl(item.currency_id)}`,
        },
        {
          sortable: false,
          value: "receiver.name",
          text: vm.$t("payment_type"),
        },
        {
          width: "400px",
          sortable: false,
          value: "description",
          text: vm.$t("description"),
        },
        {
          value: "date",
          width: "120px",
          sortable: false,
          text: vm.$t("persian_date"),
          computed: (item) => vm.persianDateFilter(item.date, true),
        },
        {
          value: "date",
          width: "120px",
          sortable: false,
          text: vm.$t("date"),
          computed: (item) => vm.persianDateFilter(item.date),
        },
        {
          value: "time",
          width: "120px",
          sortable: false,
          text: vm.$t("time"),
        }, {
          width: "120px",
          sortable: false,
          value: "risk_category",
          text: vm.$t("risk_profile"),
        },
      ];
      if (vm.trashed) {
        items.push({
          sortable: false,
          value: "deleted_at",
          text: vm.$t("deleted_at"),
        });
      }
      if (vm.reportView) {
        items.push({
          sortable: false,
          value: "user.name",
          text: vm.$t("user"),
        });
      }
      items.push({
        sortable: false,
        value: "actions",
        hidePrint: true,
        text: vm.$t("actions"),
      });
      return items;
    },
  },
  methods: {
    reset() {
      this.editIndex = -1;
      this.editDialog = false;
      this.debit = this.itemForEdit = {
        files: [],
        id: undefined,
        amount: undefined,
        date: this.debit.date,
        receiver_id: null,
        description: null,
        customer_id: null,
        time: new Date().toLocaleTimeString([], { hour12: false }),
      };
    },

    initData() {
      if (!this.initList) return;
      this.loading = true;
      let {
        search,
        trashed,
        end_date,
        branch_id,
        customer_id,
        start_date,
        reportView,
        filter_date,
        risk_category
      } = this;
      const { page, rowsPerPage } = this.pagination;
      let params = {
        page,
        search,
        trashed,
        end_date,
        branch_id,
        customer_id,
        start_date,
        reportView,
        filter_date,
        risk_category,
        per_page: rowsPerPage,
        currency_id: this.selected_currency.id,
      };
      this.axios
        .get(`debits`, { params })
        .then((resp) => {
          this.meta = resp.data.meta;
          this.items = resp.data.data;
          this.pagination.totalItems = resp.data.meta.total;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    currencyChanged(item) {
      this.selected_currency = item;
      this.initData();
    },
    saved(payload) {
      this.editDialog = false;
      this.initData();
      // if (this.editIndex < 0) this.computedItems.push(payload);
      // else this.computedItems.splice(this.editIndex, 1, payload);
      this.$emit("saved", payload);
      // this.reset();
    },

    showDebit(item) {
      this.showItem = {
        debit: item,
        customer: item.customer,
      };
      this.dialog = true;
    },

    editItem(item) {
      this.editIndex = this.computedItems.indexOf(item);
      this.itemForEdit = Object.assign({}, item);
      this.editDialog = true;
    },

    deleteItem(item) {
      let vm = this;
      this.$alert("debits/" + item.id).then(() => {
        vm.computedItems.splice(vm.computedItems.indexOf(item), 1);
        vm.getCustomers();
        vm.$emit("saved");
      });
    },

    printTable(excel) {
      let items = [...this.$refs.tbl.filteredItems];
      for (let currency in this.summery.currencies) {
        items.push({
          customer: {
            full_name: this.$t("total") + " " + this.smbl(currency),
          },
          currency_id: currency,
          amount: this.summery.amount[currency],
        });
      }

      let data = {
        items,
        landscape: true,
        brnch_name: `${this.$t("debits")} ${this.brnch_name}`,
        headers: this.headers.filter((x) => !x.hidePrint),
        title: `${this.$t("from")} ( ${
          this.initList ? this.start_date : this.st_date
        }  ${this.persianDateFilter(
          this.initList ? this.start_date : this.st_date,
          true
        )} ) ${this.$t("to")} ( ${
          this.initList ? this.end_date : this.en_date
        } ${this.persianDateFilter(
          this.initList ? this.end_date : this.en_date,
          true
        )} )`,
      };

      if (excel)
        return this.xl_tables(data, "cash-payments", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },

  created() {
    this.reset();
  },

  watch: {
    pagination: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    branch_id: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    trashed: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    customer_id: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    risk_category: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    search: debounce(function (newVal) {
      this.initData(newVal);
    }, 1000),
  },
  beforeRouteLeave(to, from, next) {
    if (this.debit.customer_id) {
      const answer = window.confirm(this.$t("unsave_alert"));
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else next();
  },
};
</script>
